import { Component, OnInit } from '@angular/core';
import { PropertyService } from 'src/app/_services/property.service';
import { AddhammaddeComponent } from 'src/app/hammadde/addhammadde/addhammadde.component';
import { AddpropertyComponent } from './addproperty/addproperty.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-propertydef',
  templateUrl: './propertydef.component.html',
  styleUrls: ['./propertydef.component.css']
})
export class PropertydefComponent implements OnInit {
  filteredhammeddeler:any[]=[];
  constructor(private propertyService:PropertyService,    private modal:NgbModal,) { }

  ngOnInit() {
    this.getProperties();
  }


  getProperties(){
    this.propertyService.getHammaddeler().subscribe((data:any)=>{
      this.filteredhammeddeler=data;
    });
  }

  openSaveModal(){
    const modalref=  this.modal.open(AddpropertyComponent, { size: 'lg' });
   
    modalref.result.then((result)=>{
     this.getProperties();
    });
    }

    openEditModal(data:any){
      const modalref=  this.modal.open(AddpropertyComponent, { size: 'lg' });
      modalref.componentInstance.hammadde=data;
      modalref.result.then((result)=>{
       this.getProperties( );
      });
      }

}
